import { Avatar, Menu, MenuHeader, MenuItem, MenuSection, MenuSeparator, Text } from '@change/ds-core-ui';
import { MenuIcon } from '@change/ds-icons/MenuIcon';
import { HeaderLayoutButton } from '@change/ds-layout';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useDropdown } from './hooks/useDropdown';

export const Dropdown: React.FC<Props> = ({ mobile }) => {
	const {
		data: { avatarUrl, navLinks, atLeastIdentified, logoutUrl, userName },
	} = useDropdown({ mobile: !!mobile });
	const { translate } = useI18n();

	return (
		<Menu
			isNonModal
			triggerAriaLabel={translate('fe.components.header.menu')}
			triggerContent={
				!atLeastIdentified || mobile ? (
					// aria-label set to empty string to satisfy required property + prevent a11y warning due to aria-label on div
					<HeaderLayoutButton
						as="div"
						aria-label=""
						data-qa="header-dropdown-button"
						iconOnly
						leadingIcon={<MenuIcon />}
					/>
				) : (
					(open) => (
						<Avatar
							src={avatarUrl}
							alt=""
							size="small"
							className="h-8 w-8"
							insetBorder
							hoverBorder
							forceHoverBorder={open}
						/>
					)
				)
			}
			placement="top right"
			contentClassName="py-0.5 w-screen -ml-3 md:ml-0 md:w-[208px]"
			triggerClassName="rounded-full"
			triggerQaAttribute="header-dropdown-button"
			contentQaAttribute="header-dropdown-menu"
		>
			{atLeastIdentified && (
				<MenuSection>
					<MenuHeader>
						<Text className="my-1 flex min-h-9 items-center px-3 font-bold" data-qa="header-user-name">
							{userName}
						</Text>
					</MenuHeader>
				</MenuSection>
			)}
			{navLinks.map((navLink) => (
				<MenuItem
					key={navLink.href}
					href={navLink.href}
					data-qa={navLink.qaAttribute}
					onAction={navLink.onClick}
					className="hover:text-typography-strong mx-1.5 my-1 no-underline focus:outline focus:outline-solid"
					label={navLink.label}
				/>
			))}
			<MenuSeparator />
			{atLeastIdentified ? (
				<MenuItem
					key="logout"
					href={logoutUrl}
					data-qa="header-logout-link"
					className="hover:text-typography-strong mx-1.5 my-1 no-underline"
					label={translate('fe.components.header.log_out')}
				/>
			) : (
				<MenuItem
					key="login"
					href="/login_or_join?user_flow=nav"
					data-qa="header-login-link"
					className="hover:text-typography-strong mx-1.5 my-1 no-underline"
					label={translate('fe.pages.login.title')}
				/>
			)}
		</Menu>
	);
};

type Props = {
	mobile?: boolean;
};
